import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCMSBlock(blockKey: string) {
  return useQuery({
    queryKey: ["cms-block", blockKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("cms_blocks" as any)
        .select("*")
        .eq("block_key", blockKey)
        .maybeSingle();
      if (error) throw error;
      return data as unknown as { block_key: string; block_type: string; content: any; updated_at: string } | null;
    },
    staleTime: 5 * 60 * 1000,
  });
}
